import { createFeatureSelector, createSelector } from '@ngrx/store';
import { SessionState } from './session.reducer';

export const selectSessionState = createFeatureSelector<SessionState>('session');

export const selectSessionId = createSelector(selectSessionState, (s) => s.sessionId);
export const selectSessionStatus = createSelector(selectSessionState, (s) => s.status);
export const selectClientName = createSelector(selectSessionState, (s) => s.clientName);
export const selectCurrentPhase = createSelector(selectSessionState, (s) => s.currentPhase);
export const selectWebsocketUrl = createSelector(selectSessionState, (s) => s.websocketUrl);
export const selectMessages = createSelector(selectSessionState, (s) => s.messages);
export const selectSlides = createSelector(selectSessionState, (s) => s.slides);
export const selectDeckVersion = createSelector(selectSessionState, (s) => s.deckVersion);
export const selectTotalSlides = createSelector(selectSessionState, (s) => s.totalSlides);
export const selectConnectionState = createSelector(selectSessionState, (s) => s.connectionState);
export const selectIsConnected = createSelector(selectConnectionState, (cs) => cs === 'connected');
export const selectIsReconnecting = createSelector(selectConnectionState, (cs) => cs === 'reconnecting');
export const selectIsLoading = createSelector(selectSessionState, (s) => s.isLoading);
export const selectIsAgentTyping = createSelector(selectSessionState, (s) => s.isAgentTyping);
export const selectProposalId = createSelector(selectSessionState, (s) => s.proposalId);
export const selectError = createSelector(selectSessionState, (s) => s.error);
export const selectErrorRetryAvailable = createSelector(selectSessionState, (s) => s.errorRetryAvailable);
export const selectExportInfo = createSelector(selectSessionState, (s) => ({
  downloadUrl: s.exportDownloadUrl,
  fileName: s.exportFileName,
  expiresAt: s.exportExpiresAt,
}));

// Derived selectors
export const selectHasSession = createSelector(selectSessionId, (id) => id !== null);
export const selectIsExportPhase = createSelector(selectCurrentPhase, (p) => p === 'EXPORT');
export const selectHasSlides = createSelector(selectSlides, (s) => s.length > 0);

// Handoff / campaign info selectors
export const selectHandoff = createSelector(selectSessionState, (s) => s.handoff);
export const selectLogoUrl = createSelector(selectSessionState, (s) => s.logoUrl);
export const selectUserInput = createSelector(selectSessionState, (s) => s.userInput);
